export function isBildMatchLive(match_date, match_time, finished) {
    if (finished === "yes") return false;
    if (!match_date || !match_time) return false;
    const [day, month, year] = match_date?.split(".").map(Number);
    const [hour, minute] = match_time?.split(":").map(Number);


    // Convert Berlin local time to a UTC Date, using DST rules
    const matchStart = berlinLocalToUTC(year, month, day, hour, minute);

    // End time = start + 120 minutes
    const matchEnd = new Date(matchStart.getTime() + 120 * 60 * 1000);
    const now = new Date(); // current time (internally UTC)

    return now >= matchStart && now <= matchEnd;
}

export function isBildMatchFinished(match_date, match_time) {
    if (!match_date || !match_time) return false;
    const [day, month, year] = match_date?.split(".").map(Number);
    const [hour, minute] = match_time?.split(":").map(Number);


    // Convert Berlin local time to a UTC Date, using DST rules
    const matchStart = berlinLocalToUTC(year, month, day, hour, minute);

    // End time = start + 120 minutes
    const matchEnd = new Date(matchStart.getTime() + 120 * 60 * 1000);
    const now = new Date(); // current time (internally UTC)

    return now >= matchEnd;
}

export function isSDMatchLive(plannedKickoffTime, finished) {
    if (finished) return false;
    if (!plannedKickoffTime) return false;

    // ISO UTC timestamp
    const matchStart = new Date(plannedKickoffTime);

    // Match duration = 120 minutes
    const matchEnd = new Date(
        matchStart.getTime() + 120 * 60 * 1000
    );

    const now = new Date();

    return now >= matchStart && now <= matchEnd;
}

export function isSDMatchFinished(plannedKickoffTime) {
    if (!plannedKickoffTime) return false;

    // ISO UTC timestamp
    const matchStart = new Date(plannedKickoffTime);

    // Match duration = 120 minutes
    const matchEnd = new Date(
        matchStart.getTime() + 120 * 60 * 1000
    );

    const now = new Date();

    return now >= matchEnd;
}

/**
 * Convert a Berlin local date/time to a UTC Date, handling DST.
 */
function berlinLocalToUTC(year, month, day, hour, minute) {
    // Treat the given date/time as if it were local Berlin time.
    // First, create a "local" timestamp in abstract form.
    const localMs = Date.UTC(year, month - 1, day, hour, minute);

    // Determine if this local time is in DST for Berlin.
    const isDst = isBerlinDST(year, month, day, hour, minute);

    // Berlin is UTC+1 in standard time, UTC+2 in DST.
    const offsetHours = isDst ? 2 : 1;

    // Local = UTC + offset -> UTC = Local - offset
    const utcMs = localMs - offsetHours * 60 * 60 * 1000;

    return new Date(utcMs);
}

/**
 * Europe/Berlin DST:
 *  - Starts last Sunday of March at 01:00 UTC
 *  - Ends   last Sunday of October at 01:00 UTC
 */
function isBerlinDST(year, month, day, hour, minute) {
    const current = new Date(Date.UTC(year, month - 1, day, hour, minute));

    const dstStart = lastSundayOfMonthUTC(year, 2, 1); // March (2), 01:00 UTC
    const dstEnd = lastSundayOfMonthUTC(year, 9, 1); // October (9), 01:00 UTC

    return current >= dstStart && current < dstEnd;
}

/**
 * Get last Sunday of a month (in UTC) at a given hour.
 * monthIndex is 0-based (0 = Jan, 2 = Mar, 9 = Oct, etc.).
 */
function lastSundayOfMonthUTC(year, monthIndex, hourUTC) {
    // Start at last day of the month
    const d = new Date(Date.UTC(year, monthIndex + 1, 0, hourUTC, 0, 0));

    // Move back to Sunday
    const dayOfWeek = d.getUTCDay(); // 0 = Sunday
    d.setUTCDate(d.getUTCDate() - dayOfWeek);

    return d;
}
